import { useState } from 'react';
import { $addUserAccountsStore } from '@lib/store';
import type { GetAccountUsersResponse } from '@shared/api/rest/users';
import { Multiselect } from '@shared/widgets/select';
import { Button, Modal } from '@shared/widgets';
import { useUnit } from 'effector-react';

interface IModalAddManager {
  title: string;
  onClose: (confirm?: boolean) => void;
  data: GetAccountUsersResponse[];
  accountId: number;
  isOpen: boolean;
}

export const ModalAddManager = (props: IModalAddManager) => {
  const addUserAccounts = useUnit($addUserAccountsStore.store);

  const [selectedManagers, setSelectedManagers] = useState<string[]>([]);

  const handleConfirm = async () => {
    if (selectedManagers.length === 0) {
      props.onClose();
      return;
    }

    for (const manager of selectedManagers) {
      await $addUserAccountsStore.events.add({
        userIds: manager,
        accountIds: [props.accountId],
      });
    }

    props.onClose(true);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={() => props.onClose()} title={props.title}>
      <Multiselect
        items={props.data.filter((user) => !user.locked).map((el) => ({ label: `${el.firstName} ${el.lastName}`, value: el.id }))}
        value={selectedManagers}
        nullValue={{ isEnable: false, text: 'Select managers' }}
        onChange={(val) => setSelectedManagers(val!)}
      />
      <Button className='mt-8' color='primary' fullWidth disabled={addUserAccounts.loading} onClick={handleConfirm}>
        Add
      </Button>
    </Modal>
  );
};
